import React, { useState, useRef, useEffect } from "react";
import {
  Table,
  Card,
  CardBody,
  CardTitle,
  Button,
  Collapse,
  Row,
} from "reactstrap";
import { useLocation } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
//redux
import { connect } from "react-redux";
//componentes
import Pagination from "../../../components/Paginationv3";
import TableTransfer from "./tableTransfer";
import ModalLinksEmbeded from "../Voo/ModalLinksEmbeded";
//useQuery
import { useQueries } from "react-query";

//componentes
import ModalNewTransfer from "./ModalNewTransfer";
import ImportTransfer from "./ImportTransfer";
import ModalImportWrapper from "./ModalImportWrapper";
import SearchFilters from "../../../components/SearchFilters";
import ActionButtonRounded from "../../../components/Buttons/ActionButtonRounded";
import ModalConfirmDeleteAll from "../../../components/ModalConfirmDeleteAll";

//services
import {
  getTransfer,
  deleteAllTransfers,
} from "../../../utils/services/transfer";
import { getParticipantsLogistic } from "../../../utils/services/participants";

import useDebounce from "../../../utils/hooks/useDebounce";
import { createXlsx } from "./createXlsx";
import WaitExport from "../../../components/WaitExport";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";

const columnsFilter = [
  { name: "Participante", value: "login", type: "text" },
  { name: "Empresa", value: "company", type: "text" },
  { name: "Origem", value: "origin", type: "text" },
  { name: "Destino", value: "destination", type: "text" },
  { name: "Data Embarque", value: "boardingdate", type: "date" },
  { name: "Data Chegada", value: "arrivaldate", type: "date" },
];
const columnsFilterLogistic = [
  ...columnsFilter,
  { name: "Tipo de Cadastro", value: "registrationtype", type: "text" },
];

function Transfer(props) {
  //pesquisa
  const [search, setSearch] = useState("");
  //modais
  const [modalNewTransfer, setModalNewTransfer] = useState(false);
  const [modalEditTransfer, setModalEditTransfer] = useState(false);
  const [modalImportTransfer, setModalImportTransfer] = useState(false);
  const [modalLinksEmbeded, setModalLinksEmbeded] = useState(false);
  const [modalDeleteAll, setModalDeleteAll] = useState(false);
  const [transfer, setTransfer] = useState([]);
  //deletar transfer
  const [success_dlg, setsuccess_dlg] = useState(false);
  const [dynamic_title, setdynamic_title] = useState("");
  const [dynamic_description, setdynamic_description] = useState("");
  //editar participante
  const [editTransfer, setEditTransfer] = useState();
  //paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  //state de participants
  const participants = useRef(null);
  // eslint-disable-next-line no-unused-vars
  const [countData, setCountData] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const location = useLocation();
  const idEvent = location.state.idEvent;

  // export in progress
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);
  // collapse
  const [isOpen, setIsOpen] = useState(false);
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("login");
  const [modalImportWrapper, setModalImportWrapper] = useState(false);
  // exibir botão deletar todos
  const [showDeleteAll, setShowDeleteAll] = useState(false);

  const debouncedSearch = useDebounce(search, 300);

  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }
  const reverseDate = () => {
    const reverse = debouncedSearch
      .split("/")
      .reverse()
      .join("/")
      .replace(/\//g, "-");
    return reverse;
  };

  function checkProductExists(product) {
    if (location.state) {
      const search = location.state.event.product.filter(
        (e) => e.name === product,
      );

      if (search[0]) {
        return true;
      } else return false;
    }
  }

  function treatmentSearch() {
    let columnFilter = checkProductExists("Inteegra MOBI")
      ? columnsFilterLogistic
      : columnsFilter;
    if (
      columnFilter.filter((item) => item.value === activeFilter)[0].type ===
      "date"
    ) {
      return reverseDate();
    }
    return debouncedSearch;
  }

  function toggleNewTransfer() {
    setModalNewTransfer(!modalNewTransfer);
  }

  function toggleImportParticipant() {
    setModalImportTransfer(!modalImportTransfer);
  }

  function toggleImportWrapper() {
    setModalImportWrapper(!modalImportWrapper);
  }

  async function confirmDeleteAllTransfers() {
    await deleteAllTransfers({
      jwt: props.state.global_user_data.data.token,
      eventId: idEvent,
    }).then((response) => {
      setsuccess_dlg(true);
      setdynamic_title("Sucesso");
      setdynamic_description("Transfers deletados com sucesso");
    });
  }
  const data = useQueries([
    {
      queryKey: ["getAllParticipants" + idEvent, 1],
      queryFn: async () => {
        const partForm = await getParticipantsLogistic({
          jwt: props.state.global_user_data.data.token,
          idEvent: idEvent,
          offset: 0,
          limit: 0,
          search: "",
        });

        participants.current = partForm.data.data;
      },
    },
    {
      queryKey: [
        "getAllTranfer" +
          idEvent +
          currentIndex +
          itemsPerPage +
          debouncedSearch,
        2,
      ],
      notifyOnChangeProps: ["currentIndex"],
      queryFn: async () => {
        const transferForm = await getTransfer({
          jwt: props.state.global_user_data.data.token,
          idEvent: idEvent,
          limit: itemsPerPage,
          offset: currentIndex > 1 ? currentIndex : 1,
          search: treatmentSearch(),
          columnSearch: activeFilter,
          hasGestaoClick: checkProductExists("Inteegra MOBI")
            ? "true"
            : "false",
        });
        setCountData(transferForm.findOneTransferData.count);
        setTransfer(transferForm.findOneTransferData.data);
      },
    },
  ]);

  useEffect(() => {
    getTransfer({
      jwt: props.state.global_user_data.data.token,
      idEvent: idEvent,
      limit: itemsPerPage,
      offset: currentIndex > 1 ? currentIndex : 1,
      search: debouncedSearch,
      columnSearch: activeFilter,
      hasGestaoClick: checkProductExists("Inteegra MOBI")
        ? "true"
        : "false",
    }).then((transferForm) => {
      setCountData(transferForm.findOneTransferData.count);
      setTransfer(transferForm.findOneTransferData.data);
    });

    getParticipantsLogistic({
      jwt: props.state.global_user_data.data.token,
      idEvent: idEvent,
      offset: 0,
      limit: 0,
      search: "",
    }).then((partForm) => {
      participants.current = partForm.data.data;
    });
  }, []);

  return (
    <div>
      {modalDeleteAll && (
        <ModalConfirmDeleteAll
          isOpen={modalDeleteAll}
          toggle={() => setModalDeleteAll(false)}
          title="Deletar Transfers"
          onConfirm={confirmDeleteAllTransfers}
        />
      )}

      {modalNewTransfer && (
        <ModalNewTransfer
          isOpen={modalNewTransfer}
          toggle={toggleNewTransfer}
          idEvent={idEvent}
          data={() => {
            data[0].refetch();
            data[1].refetch();
          }}
        />
      )}

      {/* <ImportTransfer
        isOpen={modalImportTransfer}
        toggle={toggleImportParticipant}
        token={props.state.global_user_data.data.token}
        idEvent={idEvent}
        data={data}
      /> */}

      <ModalImportWrapper
        isOpen={modalImportWrapper}
        toggle={toggleImportWrapper}
        data={data}
        idEvent={idEvent}
        token=""
      />

      {modalLinksEmbeded && (
        <ModalLinksEmbeded
          isOpen={modalLinksEmbeded}
          toggle={() => setModalLinksEmbeded(false)}
          eventId={idEvent}
        />
      )}

      {success_dlg ? (
        <SweetAlert
          success
          title={dynamic_title}
          onConfirm={() => {
            data[0].refetch();
            data[1].refetch();
            setsuccess_dlg(false);
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}
      <WaitExport
        isOpen={exportInProgress}
        name="Tranfers"
        preposicao="dos"
        finishExport={finishExport}
        setFinishExport={setFinishExport}
        setExportInProgress={setExportInProgress}
      />

      <Card>
        <CardBody>
          <CardTitle>Transfer</CardTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: 10,
            }}
          >
            <Button
              color="success"
              className="btn-rounded waves-effect waves-light events-button-add"
              style={{ marginRight: 10 }}
              onClick={() => setModalLinksEmbeded(true)}
            >
              Links Para Embedar
            </Button>
          </div>

          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={
                  checkProductExists("Inteegra MOBI")
                    ? columnsFilterLogistic
                    : columnsFilter
                }
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  value={search}
                  type={
                    activeFilter === "boardingdate" ||
                    activeFilter === "arrivaldate"
                      ? "date"
                      : "text"
                  }
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => setSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type="text"
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => setSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>
              <SectionComponent
                sectionName="Opções"
                setIsOpen={setIsOpen}
                isOpen={isOpen}
              />
              <Collapse isOpen={isOpen}>
                {transfer.length > 0 && (
                  <Row className="mobile-btns-top">
                    <div
                      onClick={() =>
                        createXlsx({
                          jwt: props.state.global_user_data.data.token,
                          idEvent: idEvent,
                          limit: 100,
                          countData,
                          setFinishExport,
                        }) > setExportInProgress(true)
                      }
                    >
                      Exportar Transfers
                    </div>
                  </Row>
                )}

                <ActionButtonRounded
                  title="Importar Transfers"
                  onClick={() => setModalImportWrapper(true)}
                  type="mobile"
                />

                <ActionButtonRounded
                  title="Adicionar Transfer"
                  onClick={() => setModalNewTransfer(true)}
                  type="mobile"
                />
              </Collapse>
            </div>
            <div className="header-btns-container">
              {transfer?.length > 0 && (
                <Button
                  color="success"
                  className="btn-rounded waves-effect waves-light events-button-add"
                  onClick={() =>
                    createXlsx({
                      jwt: props.state.global_user_data.data.token,
                      idEvent: idEvent,
                      limit: 100,
                      countData,
                      setFinishExport,
                    }) > setExportInProgress(true)
                  }
                >
                  Exportar Transfers
                </Button>
              )}

              <ActionButtonRounded
                title="Importar Transfers"
                onClick={() => setModalImportWrapper(true)}
                margin={"0 5px"}
              />

              <ActionButtonRounded
                title="Adicionar Transfer"
                onClick={() => setModalNewTransfer(true)}
              />
            </div>
          </div>

          {data[1].isFetching ? (
            <div className="table-responsive">
              <Table>
                <thead className="table-light">
                  <tr>
                    <th>Participante</th>
                    <th>Empresa</th>
                    <th>Origem</th>
                    <th>Destino</th>
                    <th>Data/hora embarque</th>
                    <th>Data/hora chegada</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <LoadingSkelentonTable lines={10} cols={7} />
                </tbody>
              </Table>
            </div>
          ) : (
            <TableTransfer
              transfer={transfer}
              idEvent={idEvent}
              data={() => {
                data[0].refetch();
                data[1].refetch();
              }}
              participants={participants?.current}
            />
          )}
        </CardBody>
      </Card>
      <div
        className="bottom-navigation"
        style={{
          justifyContent: `${
            transfer?.length > 0 && showDeleteAll ? "space-between" : "end"
          }`,
        }}
      >
        {transfer?.length > 0 && (
          <ActionButtonRounded
            onClick={() => setModalDeleteAll(true)}
            title="Limpar Todos Transferes"
            action="D"
            color="danger"
            setShow={setShowDeleteAll}
            verifyShow={true}
          />
        )}
        {/* 
        Fornecer os 4 parametros obrigatórios;
        ** data - a array contendo as informações da tabela
        ** search - o state do termo de pesquisa
        ** currentIndex - posição atual do index
        ** setCurrentIndex - função para atualizar a posição atual do index
        */}
        <Pagination
          data={transfer}
          search={search}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps)(Transfer);
